export default "__VITE_ASSET__1b0e96e6__"